export default __webpack_public_path__ + "static/media/AdobeStock_169381271.977cf2da.jpg";